import { useNavigate } from 'react-router-dom';
import { Bell } from '@tamagui/lucide-icons';
import { Text, XStack } from 'tamagui';
import { useUnreadNotificationCount } from '../lib/notifications';
import { useFocusRing } from '../lib/focus-ring';

const BADGE_OVERFLOW_THRESHOLD = 10;
const ICON_SIZE = 20;

export function NotificationsBell() {
  const navigate = useNavigate();
  const { data } = useUnreadNotificationCount();
  const count = data?.count ?? 0;
  const label = count >= BADGE_OVERFLOW_THRESHOLD ? '9+' : String(count);
  const ring = useFocusRing();

  return (
    <XStack
      tag="button"
      position="relative"
      alignItems="center"
      justifyContent="center"
      width={44}
      height={44}
      borderRadius="$3"
      cursor="pointer"
      backgroundColor="transparent"
      borderWidth={0}
      hoverStyle={{ backgroundColor: '$backgroundHover' }}
      pressStyle={{ backgroundColor: '$backgroundPress' }}
      onPress={() => navigate('/notifications')}
      aria-label={count > 0 ? `Notifications (${count} unread)` : 'Notifications'}
      {...ring}
    >
      <Bell size={ICON_SIZE} color="$color10" />
      {count > 0 ? (
        <XStack
          position="absolute"
          top={6}
          right={6}
          minWidth={18}
          height={18}
          borderRadius={9}
          backgroundColor="$danger"
          alignItems="center"
          justifyContent="center"
          paddingHorizontal={4}
        >
          <Text color="$white" fontSize={11} fontWeight="700" lineHeight={18}>
            {label}
          </Text>
        </XStack>
      ) : null}
    </XStack>
  );
}
